import { useState } from 'react'

import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Stack,
  Button,
  Select,
  MenuItem,
  TextField
} from '@mui/material'

import { OkIcon } from 'shared/icons'

import { Section } from 'components/controls/section'

import { KojinPptxFormatList } from 'features/kojin/report/pptx'
import { KojinPrintFormatList } from 'features/kojin/report/print'

import { DialogBase } from 'components/dialog'
import { useUserSession } from 'features/session/context'

export type FormatTypes = 'report' | 'pptx'

export interface KojinDownloadParams {
  title: string
  format: FormatTypes
  reportId: string | null
}
type KojinDownloadDialogProps = {
  downloading: boolean
  defaultTitle: string
  onDownload: (params: KojinDownloadParams) => void
  onClose: () => void
}
export const KojinDownloadDialog = ({
  downloading,
  defaultTitle,
  onDownload,
  onClose
}: KojinDownloadDialogProps) => {
  const { domain } = useUserSession()

  const [title, setTitle] = useState<string>(defaultTitle)
  const [format, setFormat] = useState<FormatTypes>('report')
  const [reportId, setReportId] = useState<string | null>('default')

  return (
    <DialogBase
      open
      fullWidth
      maxWidth="sm"
      title="ダウンロード"
      isLoading={downloading}
      body={
        <Stack direction="column">
          <FormControl>
            <Section label="タイトル" labelProps={{ paddingY: 2 }}>
              <TextField
                hiddenLabel
                fullWidth
                variant="outlined"
                size="small"
                value={title}
                onChange={(event) => setTitle(event.target.value)}
              />
            </Section>
          </FormControl>

          <FormControl>
            <Section label="形式" labelProps={{ paddingY: 2 }}>
              <RadioGroup
                value={format}
                name="download-format"
                onChange={(e) => setFormat(e.target.value as FormatTypes)}
              >
                <FormControlLabel
                  value="report"
                  control={<Radio />}
                  label="レポート"
                />
                <FormControlLabel
                  value="pptx"
                  control={<Radio />}
                  label="PowerPoint形式"
                />
              </RadioGroup>
            </Section>
          </FormControl>

          <FormControl>
            <Section label="内容" labelProps={{ paddingY: 2 }}>
              {format === 'report' ? (
                <Select
                  id="targetList"
                  variant="outlined"
                  value={reportId}
                  onChange={(event) =>
                    setReportId(event.target.value as string)
                  }
                  size="small"
                >
                  {KojinPrintFormatList.map((reportFormat) => {
                    return (
                      <MenuItem
                        key={`reportFormat-${reportFormat.reportId}`}
                        value={reportFormat.reportId}
                      >
                        {reportFormat.reportName}
                      </MenuItem>
                    )
                  })}
                </Select>
              ) : format === 'pptx' ? (
                <Select
                  id="targetList"
                  variant="outlined"
                  value={reportId}
                  onChange={(event) =>
                    setReportId(event.target.value as string)
                  }
                  size="small"
                >
                  {KojinPptxFormatList.flatMap((reportFormat) => {
                    if (reportFormat.domain && !reportFormat.domain.includes(domain)) return []
                    return (
                      <MenuItem
                        key={`reportFormat-${reportFormat.reportId}`}
                        value={reportFormat.reportId}
                      >
                        {reportFormat.reportName}
                      </MenuItem>
                    )
                  })}
                </Select>
              ) : (
                <></>
              )}
            </Section>
          </FormControl>
        </Stack>
      }
      action={{
        right: (<>
          <Button
            variant="contained"
            type="submit"
            startIcon={<OkIcon />}
            onClick={() => {
              onDownload({ title, format, reportId })
            }}
          >
            実 行
          </Button>
          <Button variant="text" onClick={onClose}>
            キャンセル
          </Button>
        </>)
      }}
      onClose={() => {
        if (!downloading) onClose()
      }}
    />
  )
}
